import AsyncStorage from '@react-native-async-storage/async-storage';
import {useNavigation} from '@react-navigation/native';
import React, {ReactNode, useRef, useState} from 'react';
import {Animated} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useTheme} from 'styled-components/native';

import analytics from '@react-native-firebase/analytics';
import {trackEvent} from '../../../lib/analytics';
import {AppEventsLogger} from 'react-native-fbsdk-next';

import {
  Container,
  ContainerText,
  Content,
  Dot,
  DotContainer,
  DotIcon,
  Footer,
  Header,
  ImageBoarding,
  LinkButton,
  LinkButtonContainer,
  LinkButtonText,
  Subtitle,
  Title,
} from './styles';

import {Button} from '../../../components/Interface/Forms/Buttons/Button';
import {Header as NavHeader} from '../../../components/Interface/Headers/Header';

interface ITelas {
  backgroundUrl: string;
  imageComponent: ReactNode;
  title: string;
  text: string;
  buttonName: string;
  firebaseEvent: string;
  facebookEvent: string;
}

export function OnboardingFeatures() {
  const navigation = useNavigation();
  const theme = useTheme();

  const fadeAnim = useRef(new Animated.Value(0)).current;

  async function handleFinishOnboarding() {
    if (tela === telas.length - 1) {
      trackEvent('onboarding_completo');
    }

    await AsyncStorage.setItem('onboarding', 'alreadyShowed');
    return navigation.navigate('Home');
  }

  const [tela, setTela] = useState(0);

  const telas: ITelas[] = [
    {
      backgroundUrl: theme.colors.green_light,
      imageComponent: (
        <ImageBoarding
          source={{uri: "https://d3ag5cip9ldvh3.cloudfront.net/onboarding/home.png"}}
          resizeMode="cover"
          style={{
            shadowColor: theme.colors.black,
            shadowOffset: {width: 0, height: 7},
            shadowOpacity: 0.2,
            shadowRadius: 6,
            elevation: 8,
          }}
        />
      ),
      title: 'Bem-vindo ao Baratão!',
      text: 'Aqui você encontra as melhores opções para facilitar sua rotina e economizar em abastecimentos e serviços.',
      buttonName: 'Próximo',
      firebaseEvent: 'onboarding_bem_vindo',
      facebookEvent: 'onboarding_bem_vindo',
    },
    {
      backgroundUrl: theme.colors.green_light,
      imageComponent: (
        <ImageBoarding
          source={{
            uri: 'https://d3ag5cip9ldvh3.cloudfront.net/onboarding/tipos.png',
          }}
          resizeMode="cover"
          style={{
            shadowColor: theme.colors.black,
            shadowOffset: {width: 0, height: 7},
            shadowOpacity: 0.2,
            shadowRadius: 6,
            elevation: 8,
          }}
        />
      ),
      title: 'Escolha o que precisa',
      text: 'Selecione o tipo de produto ou serviço que deseja e veja as opções disponíveis.',
      buttonName: 'Próximo',
      firebaseEvent: 'onboarding_escolha_tipo',
      facebookEvent: 'onboarding_escolha_tipo',
    },
    {
      backgroundUrl: theme.colors.green_light,
      imageComponent: (
        <ImageBoarding
          source={{
            uri: 'https://d3ag5cip9ldvh3.cloudfront.net/onboarding/postos.png',
          }}
          resizeMode="cover"
          style={{
            shadowColor: theme.colors.black,
            shadowOffset: {width: 0, height: 7},
            shadowOpacity: 0.2,
            shadowRadius: 6,
            elevation: 8,
          }}
        />
      ),
      title: 'Encontre o melhor posto',
      text: 'Veja os postos e lojas credenciados próximos de você e escolha o mais conveniente.',
      buttonName: 'Próximo',
      firebaseEvent: 'onboarding_encontre_posto',
      facebookEvent: 'onboarding_encontre_posto',
    },
    {
      backgroundUrl: theme.colors.green_light,
      imageComponent: (
        <ImageBoarding
          source={{
            uri: 'https://d3ag5cip9ldvh3.cloudfront.net/onboarding/produtos.png',
          }}
          resizeMode="cover"
          style={{
            shadowColor: theme.colors.black,
            shadowOffset: {width: 0, height: 7},
            shadowOpacity: 0.2,
            shadowRadius: 6,
            elevation: 8,
          }}
        />
      ),
      title: 'Escolha e customize',
      text: 'Selecione o produto, defina as quantidades ou litragem e finalize sua escolha.',
      buttonName: 'Próximo',
      firebaseEvent: 'onboarding_escolha_customize',
      facebookEvent: 'onboarding_escolha_customize',
    },
    {
      backgroundUrl: theme.colors.green_light,
      imageComponent: (
        <ImageBoarding
          source={{
            uri: 'https://d3ag5cip9ldvh3.cloudfront.net/onboarding/checkout.png',
          }}
          resizeMode="cover"
          style={{
            shadowColor: theme.colors.black,
            shadowOffset: {width: 0, height: 7},
            shadowOpacity: 0.2,
            shadowRadius: 6,
            elevation: 8,
          }}
        />
      ),
      title: 'Checkout rápido e seguro',
      text: 'Finalize seu pedido com poucos cliques. Escolha a forma de pagamento e receba sua confirmação instantaneamente.',
      buttonName: 'Próximo',
      firebaseEvent: 'onboarding_checkout',
      facebookEvent: 'onboarding_checkout',
    },
    {
      backgroundUrl: theme.colors.green_light,
      imageComponent: (
        <ImageBoarding
          source={{
            uri: 'https://d3ag5cip9ldvh3.cloudfront.net/onboarding/cupons.png',
          }}
          resizeMode="cover"
          style={{
            shadowColor: theme.colors.black,
            shadowOffset: {width: 0, height: 7},
            shadowOpacity: 0.2,
            shadowRadius: 6,
            elevation: 8,
          }}
        />
      ),
      title: 'Use seus cupons',
      text: 'Apresente seus cupons para resgatar produtos ou serviços nos estabelecimentos credenciados.',
      buttonName: 'Próximo',
      firebaseEvent: 'onboarding_cupons',
      facebookEvent: 'onboarding_cupons',
    },
    {
      backgroundUrl: theme.colors.green_light,
      imageComponent: (
        <ImageBoarding
          source={{
            uri: 'https://d3ag5cip9ldvh3.cloudfront.net/onboarding/indique.png',
          }}
          resizeMode="cover"
          style={{
            shadowColor: theme.colors.black,
            shadowOffset: {width: 0, height: 7},
            shadowOpacity: 0.2,
            shadowRadius: 6,
            elevation: 8,
          }}
        />
      ),
      title: 'Indique e ganhe',
      text: 'Gerencie seus indicados e ative os melhores para ganhar ainda mais recompensas!',
      buttonName: 'Ir para o app',
      firebaseEvent: 'onboarding_indique',
      facebookEvent: 'onboarding_indique',
    },
  ];

  function logAnalyticsEvent(firebaseEvent: string, facebookEvent: string) {
    analytics().logEvent(firebaseEvent);
    AppEventsLogger.logEvent(facebookEvent);
  }

  function handle() {
    fadeAnim.setValue(0);
    let index = tela + 1;

    if (telas.length > index) {
      Animated.timing(fadeAnim, {
        toValue: -500,
        duration: 200,
        useNativeDriver: true,
      }).start(() => {
        fadeAnim.setValue(500);

        Animated.timing(fadeAnim, {
          toValue: 0,
          duration: 200,
          useNativeDriver: true,
        }).start(() => {});

        setTela(index);
        logAnalyticsEvent(
          telas[index].firebaseEvent,
          telas[index].facebookEvent,
        );
      });
    } else {
      handleFinishOnboarding();
    }
  }

  function voltar() {
    fadeAnim.setValue(0);

    Animated.timing(fadeAnim, {
      toValue: 500,
      duration: 200,
      useNativeDriver: true,
    }).start(() => {
      fadeAnim.setValue(-500);

      Animated.timing(fadeAnim, {
        toValue: 0,
        duration: 200,
        useNativeDriver: true,
      }).start(() => {});

      let index = tela - 1;

      if (index >= 0) {
        setTela(index);
        logAnalyticsEvent(
          telas[index].firebaseEvent,
          telas[index].facebookEvent,
        );
      } else {
        return null;
      }
    });
  }

  function skip() {
    logAnalyticsEvent('onboarding_skip', 'onboarding_skip');
    handleFinishOnboarding();
  }

  return (
    <Container>
      <Header style={{backgroundColor: telas[tela].backgroundUrl}}>
        {tela !== 0 && (
          <NavHeader
            icon="chevron-left"
            forceDarkStatusBar
            action={voltar}
            color={theme.colors.black}
          />
        )}
      </Header>
      <Animated.View
        style={{
          flex: 1,
          transform: [
            {
              translateX: fadeAnim,
            },
          ],
        }}>
        <Content>
          {telas[tela].imageComponent}

          <ContainerText>
            <Title>{telas[tela].title}</Title>
            <Subtitle>{telas[tela].text}</Subtitle>
          </ContainerText>
        </Content>
      </Animated.View>
      <Footer>
        <SafeAreaView>
          <DotContainer>
            {telas.map((item, index) => (
              <Dot key={index}>
                <DotIcon
                  name="circle"
                  style={{
                    color:
                      tela === index ? theme.colors.blue : theme.colors.border,
                  }}
                />
              </Dot>
            ))}
          </DotContainer>
          <Button title={telas[tela].buttonName} onPress={handle} enabled />

          {telas.length !== tela + 1 && (
            <LinkButtonContainer>
              <LinkButton activeOpacity={1} onPress={skip}>
                <LinkButtonText>Pular introdução</LinkButtonText>
              </LinkButton>
            </LinkButtonContainer>
          )}
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
